<template>
  <v-container class="pa-0" fluid>
    <Features class="py-12" :show-types="['base', 'base-more', 'extra']" />
  </v-container>
</template>

<script>
// @ is an alias to /src
import Features from "@/components/features/Features.vue";

export default {
  components: {
    Features
  }
};
</script>